import React from "react";
import clsx from "clsx";

export type Tab = {
  name: string;
  onClick: () => void;
  current: boolean;
  disabled?: boolean;
  showIncompleteIndicator?: boolean;
  labelNode?: React.ReactNode;
};

const YellowDotIcon = (
  <svg
    className="h-[11px] w-[11px]"
    width="11"
    height="12"
    viewBox="0 0 11 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="5.5" cy="6" r="5.5" fill="#FFBA09" />
  </svg>
);

export default function TabsWithUnderline({
  tabs,
  maxWidth = "",
  rightPadding = "",
}: {
  tabs: Tab[];
  maxWidth?: string;
  rightPadding?: string;
}) {
  return (
    <div
      className={clsx(
        "border-b border-gray-200",
        maxWidth ? maxWidth : null,
        rightPadding ? rightPadding : null,
      )}
    >
      <nav aria-label="Tabs" className="-mb-px flex space-x-8">
        {tabs.map((tab) => (
          /* A real button, not a div: these tabs are the primary navigation between pages, so
             they have to be focusable and activatable with Enter/Space. `disabled` also gives
             the dimmed tab actual disabled semantics, which aria-disabled alone does not. */
          <button
            type="button"
            key={tab.name}
            onClick={tab.onClick}
            disabled={tab.disabled}
            aria-current={tab.current ? "page" : undefined}
            className={clsx(
              tab.current
                ? "border-primary-500 text-primary-600"
                : "border-transparent text-neutral-500",
              "whitespace-nowrap border-0 border-b-2 border-solid bg-transparent px-1 py-4 text-sm font-medium",
              tab.disabled ? "opacity-50" : "cursor-pointer hover:text-neutral-700",
              { "flex gap-[6px]": tab.showIncompleteIndicator },
            )}
          >
            {tab.showIncompleteIndicator && <div className="pt-[4px]">{YellowDotIcon}</div>}
            <div>{tab.labelNode ?? tab.name}</div>
          </button>
        ))}
      </nav>
    </div>
  );
}
